<template>
  <v-container>
    <h1>{{ logoutInfo }}</h1>
  </v-container>
</template>

<script>
import { ref } from 'vue'
import { useStore } from "vuex";

export default {
  name: 'LogoutView',
  setup() {
    const store = useStore()
    
    let logoutInfo = ref(null)

    store.dispatch('oidcStore/removeOidcUser')
      .then(() => {
        store.dispatch('signOutClear')
        logoutInfo.value = "Logging out"
        if ('BroadcastChannel' in self) {
          const channel = new BroadcastChannel('logoutByOtherClient')
          channel.postMessage({ logout: true })
        }
      })
      .catch((err) => {
        console.error(err)
      })

    return { logoutInfo }
  },
  mounted() {
    this.$store.dispatch('breadcrumbModule/setRoute', [{
      name: 'breadcrumb.logout',
      url: ''
    }])
  }
}
</script>